/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React from "react";
import { DonateTitle } from "../components/DonateTitle";
import { DonateForm } from "../components/DonateForm";
import { DonateRecentDonors } from "../components/DonateRecentDonors";
import { DonateBankDetails } from "../components/DonateBankDetails";
import { MonthlyContributions } from "../components/MonthlyContributions";
import { Helmet } from "react-helmet";

export const Donate: React.FC = () => {
    return(
        <>
            <Helmet>
                <title>Donate - Jewish Cemetery</title>
                <meta name="description" content="This website was designed by the Jewish Cemeteries Maintenance Board to pay tribute to loved ones that are no longer with us." />
            </Helmet>

            <div className="jc-grid mx-auto" style={{maxWidth: "1028px"}}>
                <DonateTitle />

                <div className="row">
                    <div className="col-md-6">
                        <DonateForm endpoint={"donation/create"} />
                    </div>
                    
                    <div className="col-md-6">
                        <MonthlyContributions endpoint={"transactions/summary/monthToDate"} />
                    </div>

                    <div className="col-md-6 order-3">
                        <DonateRecentDonors endpoint={"transactions/recent"} recordCount={30} />
                    </div>

                    <div className="col-md-6 order-4">
                        <DonateBankDetails />
                    </div>
                </div>
            </div>
        </>
    );
}